package com.siriusxm.pia.rest.unifiedaggregator

import com.siriusxm.cmc.utils.getString
import unifiedcontent.aggregator.AuditContext
import unifiedcontent.aggregator.PartialUpdateOperations
import unifiedcontent.aggregator.ScheduledUpdatesList
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.jsonObject
import kotlin.time.Instant

@Serializable
class IncomingEntityResult(
    val entity: IncomingEvent,
    val partials: List<IncomingEvent>? = null,
    val scheduled: ScheduledUpdatesList? = null,
)

@Serializable
class IncomingEvent(
    val data: JsonObject,
    val source: String? = null,
    val partialId: String? = null,
    val ts: Instant? = null,
    val auditContext: AuditContext? = null,
    val operations: PartialUpdateOperations? = null,
)


@Serializable
data class EntityListResponse(
    val entities: List<JsonObject>,
    val paginationToken: String? = null
)

/**
 * Shorthand to get the entity id from entity Json
 */
val JsonElement.entityId: String? get() = jsonObject.getString("id")

/**
 * Shorthand to get the entity type from entity Json
 */
val JsonElement.entityType: String? get() = jsonObject.getString("type")

/**
 * Shorthand to get the entity type from entity Json
 */
val JsonElement.entityVersion: String? get() = jsonObject.getString("version")
